import { PackageProviderName } from 'data/ppoints/constants';
import ModalActions from 'layouts/modal-actions/modal-actions';
import { AggregatorPackageProvider } from 'models/ppoints/CountryWithAggregatedProviders';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ShippingProviderCardSimplifiedIconWithHeader } from '../ShippingProviderCardSimplifiedIconWithHeader';
import { ShippingProviderCardSimplifiedShell } from '../ShippingProviderCardSimplifiedShell';

export const SelectAggregatorProvidersModal: React.FC<SelectAggregatorProvidersModalProps> = ({
    aggregator,
    selectedProviderNames,
    onSave,
    onCancel,
}) => {
    const { t } = useTranslation();
    const [selected, setSelected] = useState<PackageProviderName[]>(selectedProviderNames);

    const toggleProvider = (providerName: PackageProviderName) => {
        setSelected((current) =>
            current.includes(providerName)
                ? current.filter((name) => name !== providerName)
                : [...current, providerName]
        );
    };

    return (
        <>
            <div className="p-4">
                <p className="pb-4">{t('SHIPPING_PROVIDERS.AGGREGATOR_MODAL.DESCRIPTION')}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {aggregator.providers.map((provider) => (
                        <ShippingProviderCardSimplifiedShell
                            key={provider.id}
                            selected={selected.includes(provider.name)}
                            onSelect={() => toggleProvider(provider.name)}
                        >
                            <ShippingProviderCardSimplifiedIconWithHeader providerName={provider.name} />
                        </ShippingProviderCardSimplifiedShell>
                    ))}
                </div>
            </div>
            <s-divider />
            <div className="p-4">
                <ModalActions
                    onSubmit={() => onSave(selected)}
                    onCancel={onCancel}
                    submitLabel={t('SHIPPING_PROVIDERS.AGGREGATOR_MODAL.SAVE')}
                    inlineAlign="end"
                />
            </div>
        </>
    );
};

interface SelectAggregatorProvidersModalProps {
    aggregator: AggregatorPackageProvider;
    selectedProviderNames: PackageProviderName[];
    onSave: (providerNames: PackageProviderName[]) => void;
    onCancel: () => void;
}
